(function () {

    'use strict';

    if (typeof window === 'undefined') {
        module.exports = exports();
    } else {
        RivalIQ.utils.keywords = exports();
    }

    function exports() {
        const utils = {};

        utils.formatQuotedKeywords = function (str) {
            // seed this with '' so we don't have to worry about word zero
            const keywords = [''];
            let c = '';
            let isDelimited = false;

            for (let i = 0; i < str.length; i++) {
                c = str[i];

                // check if this is a beginning or end of a quote delimited word
                if (c === '"') {
                    isDelimited = !isDelimited;
                } else if (c === ' ' && !isDelimited) {
                    // this is the end of a word, delimited by space
                    keywords.push('');
                } else {
                    // this is a part of a word (note: can be a space when quote delimited)
                    keywords[keywords.length - 1] += c;
                }
            }

            return keywords.join(', ');
        };

        return utils;
    }
})();
